export enum Network {
  MainNet = 'mainnet',
  TestNet = 'testnet',
  DevNet = 'devnet',
  Localhost = 'localhost',
}

export const Networks =
  process.env.NODE_ENV === 'production' ? [Network.MainNet, Network.TestNet] : Object.values(Network)
